import { FC, memo } from 'react'
import { ParsedMessageBlockWrapper } from './styled'
import { MessageDetailsTable } from './MessageDetailsTable'
import { MessageTimelineTable } from './MessageTimelineTable'
import { SplitterValues } from './TableSplitterRow'

interface Props {
    data?: any
    searchParams?: any
    selectedSeqNum: number
    onSelectedSeqNumChange: (index: number) => void
    onSortChange: (val: string) => void
    isSearch: boolean | undefined
    handleSearchChange: (searchRequest: any) => void
    handleDividerClick: (direction: SplitterValues, seqNum: number, deltaSeqNum: number) => void
    error: string
    wrapperStyle?: React.CSSProperties
}

export const ParsedMessageBlock: FC<Props> = memo(({
    data,
    searchParams,
    selectedSeqNum,
    onSelectedSeqNumChange,
    onSortChange,
    isSearch,
    handleDividerClick,
    handleSearchChange,
    error
}) => {
    if (error) {
        return (
            <div style={{
                width: 'var(--base-width)',
                paddingLeft: '16px',
                paddingRight: '16px',
                margin: 'auto',
                color: 'red',
                whiteSpace: 'pre',
                alignSelf: 'flex-start',
                textAlign: 'left',
                fontFamily: 'var(--code-font-family)',
                overflowX: 'auto'
            }}>
                Error: {error}
            </div>)
    }
    if (!data) {
        return null
    } else if (!data.length) {
        return <div style={{ textAlign: 'center' }}>No Data</div>
    }

    // @ts-ignore
    const selectedIndex = isSearch
        ? data.indexOf(data.find((el: any) => el.seqNumber === selectedSeqNum))
        : selectedSeqNum
    return (
        <ParsedMessageBlockWrapper
            isSearch={isSearch}
        >
            <MessageTimelineTable
                onSortChange={onSortChange}
                isSearch={isSearch}
                onRowSelect={onSelectedSeqNumChange}
                data={data}
                selected={selectedIndex}
                handleDividerClick={handleDividerClick}
                searchParams={searchParams}
            />
            <MessageDetailsTable isSearch={isSearch} onSearchClOrdID={handleSearchChange} data={data[selectedIndex]} />
        </ParsedMessageBlockWrapper>
    )
})
